"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disabledState = exports.disabledBorder = void 0;
require("./disabledState.css");
var _interactable = require("@cbhq/cds-common/tokens/interactable");
var _interactableCSSProperties = require("../system/interactableCSSProperties");
const disabledState = "cds-disabledState-d1bw0laf";
exports.disabledState = disabledState;
const disabledBorder = "cds-disabledBorder-d1auqh82";
exports.disabledBorder = disabledBorder;